import * as React from "react";
import { Alert, Card } from "antd";
import { CardTitle } from "../../components/antd/card/CardTitle";
import { CardContent } from "../../components/antd/card/CardContent";
import { useCpFormAnyValue, useCpFormValue } from "../gvc/testNewForm/utils";
import { CpFormItem } from "../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../gvc/testNewForm/CpErrorWarning";
import { CpArrayString } from "../gvc/testNewForm/CpArrayString";
import { CpInputNumber } from "../gvc/testNewForm/CpInputNumber";

interface Props {}
export const Observability: React.FC<Props> = ({}) => {
  const defaultAlertEmails = useCpFormValue(`observability.defaultAlertEmails`);
  const initialDefaultAlertEmails = useCpFormAnyValue(`initialValues.observability.defaultAlertEmails`);

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardTitle>Observability</CardTitle>
          <CardContent>
            <CpFormItem>
              <CpLabel name={`observability.logsRetentionDays`}>Logs Retention</CpLabel>
              <CpInputNumber name={`observability.logsRetentionDays`} addonAfter={`Days`} />
              <CpErrorWarning name={`observability.logsRetentionDays`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`observability.metricsRetentionDays`}>Metrics Retention</CpLabel>
              <CpInputNumber name={`observability.metricsRetentionDays`} addonAfter={`Days`} />
              <CpErrorWarning name={`observability.metricsRetentionDays`} />
            </CpFormItem>
            <CpFormItem>
              <CpLabel name={`observability.tracesRetentionDays`}>Traces Retention</CpLabel>
              <CpInputNumber name={`observability.tracesRetentionDays`} addonAfter={`Days`} />
              <CpErrorWarning name={`observability.tracesRetentionDays`} />
            </CpFormItem>
            <div style={{ maxWidth: 600 }}>
              <div>
                Default Alert Emails
                {initialDefaultAlertEmails.length < 1 || defaultAlertEmails.length < 1 ? (
                  <Alert
                    type={`info`}
                    showIcon
                    message={`It is highly recommended to set at least one email address`}
                  />
                ) : null}
              </div>
              <CpArrayString name={`observability.defaultAlertEmails`} />
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
